<template>
  <el-form
    class="form"
    ref="form"
    :model="self_form"
    :rules="rules"
    label-width="160px">
    <el-form-item label="商品类目" prop="categoryIds">
      <CategoryCascader v-model="self_form.categoryIds" :filterable="true"></CategoryCascader>
    </el-form-item>
    <el-form-item label="商品分类：" class="el-form-item-sellerCatName">
      {{ (self_form.sellerCatNames || []).join(', ') }}
    </el-form-item>
    <el-form-item label="分销小店展架分类：">
        <el-cascader
            width="250px"
            popper-class="popper-select"
            :options="displayClassifyOptions"
            v-model="self_form.displayCode"
            :props="{
                multiple: true,
                value:'code',
                label:'name',
                children:'list',
            }"
            :show-all-levels="false"
            filterable
            clearable
            placeholder="请选择"
        ></el-cascader>
    </el-form-item>
    <el-form-item v-if="isAddHand" label="来源店铺：">
      <ShopSelect propKey="shopIds" v-model="self_form.shopIds" :items="allShops" :attrs="{multiple: true, clearable: true, collapseTags: true, width: '200px'}"/>
    </el-form-item>
    <el-form-item label="款式编码" prop="outerId">
      <el-input v-model.trim="self_form.outerId" @blur="checkSameOuterId()" :disabled="(isDistributor && publishEntrance == 1 && !canEditOuterId)"></el-input>
      <div class="el-form-item__error" v-if="outerIdSame">
        <span style="color:#F56C6C; margin-right: 10px;">该款商品在供应链已存在，不可新增</span>
        <el-link :href="outerIdSameUrl" target="_blank">去查看</el-link>
      </div>
    </el-form-item>
    <el-form-item label="商品名称" prop="title">
      <el-input v-model="self_form.title" type="text" :maxlength="getTitleMaxLength()" @input="updateTitleWordCount">
        <span slot="suffix" style="margin-right: 6px;">{{ getTitleByteLength(self_form.title || '') }}/100</span>
      </el-input>
    </el-form-item>
    <el-form-item label="商品供应商">
      <el-select 
        filterable
        remote 
        clearable
        v-model="self_form.itemSupplier" 
        value-key="id" 
        nameKey="name"
        placeholder="请选择或搜索"
        :remote-method="remoteMethod"
        :loading="loading"
        @focus="searchSupplier"
        v-loadMore="handleMore">
        <el-option
          v-for="item in suppliers"
          :key="item.id"
          :label="item.name"
          :value="item">
        </el-option>
      </el-select>
      <el-button type="link" @click="addSupplier">新增供应商</el-button>
    </el-form-item>
    <el-form-item label="商品主图" prop="mainImages">
      <div>
        只取主图，拖动可调整顺序 
        <BatchEditImages v-model="self_form.mainImages" refName="mainImages" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages>
        <MainImagesAddon />
      </div>
      <MutiImgUpload
        ref="mainImages"
        :limitNums="50"
        :size="150"
        :outerId="self_form.outerId"
        :appendToBody="true"
        v-model="self_form.mainImages" />
    </el-form-item>
    <el-form-item label="3:4主图" prop="mainImages34">
      <div><BatchEditImages v-model="self_form.mainImages34" refName="mainImages34" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
      <MutiImgUpload
        ref="mainImages34"
        :outerId="self_form.outerId"
        :appendToBody="true"
        :limitNums="50"
        :mainImgNums="0"
        :aspectRatio="[0.75]"
        :cropDefaultSize="[750, 1000]"
        aspectRatioText="3:4"
        :size="150"
        :autoCropImageParams="{targetWidth:750,targetHeight:1000}"
        v-model="self_form.mainImages34" />
    </el-form-item>
    <el-form-item label="白底图" prop="whiteBackGroundPic">
      <MutiImgUpload
        ref="whiteBackGroundPic"
        :outerId="self_form.outerId"
        :appendToBody="true"
        :mainImgNums="0"
        :limitNums="1"
        :limitWidth="[600, 0]"
        :limitHeight="[600, 0]"
        :limitSize="5 * 1024 * 1024"
        limitSuffix=".jpg,.jpeg,.png"
        :aspectRatio="[1]"
        :cropDefaultSize="[800, 800]"
        aspectRatioText="1:1"
        :size="150"
        :autoCropImageParams="{targetWidth:600,targetHeight:600}"
        v-model="self_form.whiteBackGroundPic" />
    </el-form-item>
    <el-form-item label="商品长图" prop="longImage">
      <MutiImgUpload
        ref="longImage"
        :outerId="self_form.outerId"
        :appendToBody="true"
        :mainImgNums="0"
        :limitNums="1"
        :size="150"
        :aspectRatio="[2/3]"
        :cropDefaultSize="[800, 1200]"
        aspectRatioText="2:3"
        v-model="self_form.longImage" />
        <div style="font-size: 12px; color: #999; margin-bottom: 5px;">建议尺寸比例 2:3</div>
    </el-form-item>
    <el-form-item label="商品详情图">
      <!-- 待上传组件 -->
      <div><BatchEditImages v-model="self_form.detailImages" refName="detailImages" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
      <MutiImgUpload
        ref="detailImages"
        :outerId="self_form.outerId"
        :appendToBody="true"
        :limitNums="50"
        :mainImgNums="0"
        :size="150"
        v-model="self_form.detailImages" />
    </el-form-item>
    <el-form-item label="添加套图" class="group-images-item">
      <div>您可维护多套商品图片，铺货时可使用其中一套图片或自由组合图 
        <!-- <el-link href="https://www.yuque.com/gaypzq/yzgp7x/fosnp7iutegx2dae" target="_blank">套图使用小妙招</el-link>  -->
      </div>
      <GroupImagesList ref="GroupImagesListRef" :baseItemId="self_form.baseItemId" :selfForm="self_form" :specifications="specifications" :isEdit="true"></GroupImagesList>
    </el-form-item>
    <el-form-item v-if="pddShopCount" label="宝贝链接">
      <el-input v-model="self_form.itemUrl"></el-input>
      <p class="itemUrl-tip-text">注：仅用于铺货到拼多多店铺（平台要求必须上传拼外源商品链接，且加价最多8%） <el-link href="https://www.yuque.com/gaypzq/ftwd71/kii7uy7uv1gni8a4" target="_blank">如何获取拼外链接？</el-link></p>
    </el-form-item>
    <el-form-item label="商品描述">
      <el-input
        type="textarea"
        :rows="3"
        v-model="self_form.description"></el-input>
    </el-form-item>
    <el-form-item label="商品规格">
      <RuleSortBtn :specifications.sync="specifications"/>
      <SpecsValuesSort :specifications.sync="specifications" />
      <PureSpecsForm ref="pureSpecsFormRef" 
        :pureGoods="pureGoods"
        :erpOuterId="self_form.erpOuterId"
        :erpSkuOuterId="self_form.erpSkuOuterId"
        :baseItemId="self_form.baseItemId"
        @fieldChanged="validPage"
      />
      <FormItemSpecification key="FormItemSpecification" remarkKey="note" v-model="specifications" :pureType="pureGoods.pureType" :outerId="self_form.outerId"/>
    </el-form-item>
    <el-form-item
      label="规格明细">
      <FormItemSkuList
        ref="formItemSkuListRef"
        :specifications="specifications"
        :tableCols="skuTableCols2"
        :imgOnlyPreview="skuImgOnlyPreview"
        :erpStockImport="!isDistributorProd"
        :outerId="self_form.outerId"
        v-model="skuList"
        :pureType="pureGoods.pureType"
        @fieldChanged="specificationsFieldChanged"
        :source="source"
        :isDistribution="isDistribution"
      >
        <template slot="skuOuterIdHeaderSlot">
          <span style="color: red">*</span>商品编码<el-button @click="batchGenSkuOutrerId" type="link">批量生成</el-button>
        </template>
        <template slot="stockHeaderSlot" slot-scope="{}">
          <span style="color: red">*</span>库存
          <template v-if="isDistributorProd && pureGoods.pureType === 0 && self_form.stockType > 0">
            <el-tooltip style="line-height: 18px; padding: 0;" popper-width="200px" content="供销商已开启库存同步，默认取供销商库存，如需修改需关闭开关后手动调整，修改后库存将无法自动同步供销商库存" placement="top">
              <el-switch
                v-model="self_form.stockType"
                :active-value="1"
                :inactive-value="2"
                @change="(v) => stockTypeChange(v)">
              </el-switch>
            </el-tooltip>
          </template>
        </template>
        <template slot="stockSlot" slot-scope="{ row }">
          <template v-if="isDistributorProd && row.stockType > 0">
            <span style="width: 55px;display:inline-block;" :title="row.stock" v-if="row.stockType === 1">
              {{ row.stock }}
            </span>
            <el-input-digit
              style="width: 55px;"
              v-else
              v-model.number="row.stock"
              :nullable="true"
              :disabled="!!pureGoods.pureType"
              :precision="0"
            />
            <el-switch
              v-model="row.stockType"
              :active-value="1"
              :inactive-value="2"
              @change="(v) => skuStockTypeChange(v, row)">
            </el-switch>
            <!-- <el-switch
              v-if="row.stockType > 0"
              v-model="row.stockType"
              :active-value="1"
              :inactive-value="2">
            </el-switch> -->
          </template>
          <el-input-digit
            style="width: 55px;"
            v-else
            v-model.number="row.stock"
            :nullable="true"
            :disabled="!!pureGoods.pureType"
            :precision="0"
          />
        </template>
        <template slot="sellerCatNameSlot" slot-scope="{ row }">
          {{ (row.sellerCatNames || []).join(', ') }}
        </template>
        <template slot="skuBatchSlot">
          <el-dropdown v-if="specificationNames.length > 0" trigger="hover" @command="handleCommandSetSpecs" style="margin-left: 10px;">
              <el-button>批量设置规格<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
              <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in specificationNames" :key="item.nameKey" :command="item.nameKey">批量设置{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown>
        </template>
      </FormItemSkuList>
      <template v-if="specificationsValidResult !== true">
        <div class="el-form-item__error">{{specificationsValidResult}}</div>
      </template>
    </el-form-item>
    <el-form-item label="商品视频">
      <!-- 视频组件 -->
      <el-row style="display: flex; align-items: center;">
         <VideoUpload @upload-success="videoUploadSuccess" :video="self_form.videos['3:4']" @del="videoDel"  aspectRatio="3:4" aspectRatioText="3:4视频" :companyId="self_form.companyId"/>
         <VideoUpload @upload-success="videoUploadSuccess" :video="self_form.videos['16:9']"  @del="videoDel" aspectRatio="16:9" aspectRatioText="16:9视频" :companyId="self_form.companyId"/>
         <VideoUpload @upload-success="videoUploadSuccess" :video="self_form.videos['1:1']"  @del="videoDel" aspectRatio="1:1" aspectRatioText="1:1视频" :companyId="self_form.companyId"/>
         <VideoUpload @upload-success="videoUploadSuccess" :video="self_form.videos['9:16']"  @del="videoDel" aspectRatio="9:16" aspectRatioText="9:16视频" :companyId="self_form.companyId"/>
      </el-row>
      <el-row style="font-size:12px;margin-top:10px;">
        <el-col>分辨率 >= 300p；时长上限为180s；</el-col>
        <el-col>视频格式：mp4、mov、m4v、flv、x-flv、wmv、rm、3gp、avi，抖音只支持MP4格式</el-col>
      </el-row>
    </el-form-item>
    <!-- prop="distributionState" -->
    <el-form-item label="是否加入分销小店" prop="isPrivacyDistributionState">
      <el-radio
        v-for="(item) in DISTRIBUTION_STATE_OPTIONS"
        :key="item.value"
        v-model="self_form.isPrivacyDistributionState" :label="item.value">{{item.label}}</el-radio>
    </el-form-item>
    <el-form-item label="同步快麦通资料到ERP资料" prop="syncContent" v-if="isAddHand">
      <el-checkbox-group v-model="self_form.syncContent">
        <el-checkbox
          v-for="item in syncToErpConfList"
          :key="item.field"
          :label="item.field"
          style="margin-left: 10px"
          >{{ item.fieldName }}
        </el-checkbox>
      </el-checkbox-group>
      <!-- <el-checkbox-group v-model="self_form.syncContent">
        <el-checkbox :disabled="item.value == 'title' || item.value == 'skuOuterId' || item.value == 'skuSpecifications'" :label="item.value" v-for="item in SYNCCONTENT_FIELD" :key="item.value">
          {{item.name}}
        </el-checkbox>
      </el-checkbox-group> -->
    </el-form-item>
     <el-form-item label="同步快麦通资料到ERP资料" prop="syncContent" v-else>
      <el-checkbox-group v-model="self_form.syncContent">
        <el-checkbox :label="item.value" v-for="item in SYNCCONTENT_FIELD" :key="item.value">
          {{item.name}}
        </el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <GenSkuOuterIdDialog ref="genSkuOuterIdDialog" />
    <AddNewSupplier ref="addNewSupplier" @search="searchSupplier"/>
    <BatchSetSpecValuesDialog ref="batchSetSpecValuesDialogRef"/>
  </el-form>
</template>

<script>
import Vue from 'vue'
import { mapGetters,mapActions } from 'vuex'; 
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'
import ImgUpload from '@/components/Uploads/ImgUpload'
import BatchEditImages from '../BatchEditImages.vue'
import VideoUpload from '@/components/Uploads/videoUpload'
import CategoryCascader from '@/components/prod/center/components/CategoryCascader.vue'
import MainImagesAddon from './components/MainImagesAddon.vue'
import prod_center_dictionary from '../../dictionary'
import {specification_mixin} from '../FormItemSpecification'
import GenSkuOuterIdDialog from '../../dialogs/GenSkuOuterIdDialog.vue'
import AddNewSupplier from './components/addNewSupplier.vue'
import PureSpecsForm from './components/PureSpecsForm.vue'
import BatchSetSpecValuesDialog from './components/BatchSetSpecValuesDialog.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import { getNoPageShopData } from '@api/base/index.js';
import { checkSameOuterId, querySupplierStock, initPddBrandList} from '@/api/prod/center/index.js'
import { getCgSupplierList,getSkuErpStockList } from '@/servers/prod/center/index.js'
import { getSyncFiledConfig } from '@/servers/prod/conf/index';
import { queryBaseItemDisplay } from '@servers/base/display/index.js';
import {SYNCCONTENT_FIELD} from './dictionary'
import RULES from "./rules.js";
import validateMixin from '../validateMixin';
import ShopSelect from '../SearchSelect.vue';

export default {
  mixins: [specification_mixin, validateMixin],
  components: {
    MutiImgUpload,
    ImgUpload,
    BatchEditImages,
    CategoryCascader,
    GenSkuOuterIdDialog,
    VideoUpload,
    AddNewSupplier,
    PureSpecsForm,
    BatchSetSpecValuesDialog,
    GroupImagesList,
    ShopSelect,
    MainImagesAddon,
  },
  props: {
    platform: {
      type: String,
      default: 'base'
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    isDistributor: {
      type: Boolean,
      default: false
    },
    canEditOuterId: {
      type: Boolean,
      default: false
    },
    publishEntrance: {
      type: Number,
      default: 1
    },
    isAddHand: {
      type: Boolean,
      default: false
    },
    smallShopItem: {
      type: Boolean,
      default: false
    },
    source:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isBase: true,
      DISTRIBUTION_STATE_OPTIONS: prod_center_dictionary.IS_PRIVACY_DISTRIBUTION_STATE,
      self_form: {},
      isBaseInfo: true,
      skuImgOnlyPreview: false, // sku的预览图是否只能预览不能编辑
      needValiSymbol: true, // 校验规格名规格值非法字符
      categoryProps: {
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      categoryOptions: [],
      suppliers: [], // 我的供销商 --- 通过接口获取
      rules: RULES(this),
      SYNCCONTENT_FIELD,
      oriOuterId: '', // 原始款式编码，用于判断重复款式编码
      outerIdSame: false, // 款式编码是否重复
      outerIdSameUrl: '', // 重复后的跳转链接
      page: {
        pageNo: 1,
        pages: 1
      },
      loading: false,
      isErpSumStockLoading:false,
      // 纯商品（商品规格数据）
      pureGoods: {
        pureType: 0
      },
      origin_form: {}, // 原始商品数据
      pddShopCount: 0,
      syncToErpConfList: [],
      displayClassifyOptions:[],
      isRequestSkuStock:false,
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['removePureItem', 'shops_all','isSupplier', 'distributionLevelList']),
    allShops() {
      return this.shops_all.map(shop => ({label: shop.shortTitle || shop.title, value: shop.id, icon: shop.icon}));
    },
    isDistributorProd() {
      // 是否是商品中心-分销商品
      return this.isDistributor && this.publishEntrance === 1
    },
    skuTableCols2() {
      // 校验数字空值，0可以通过
      function valiNumVoid(value, prop) {
        if (!value && (value !== 0)) {
          return `${prop.label}请勿输入空值`
        }
        return false
      }
      let priceLevelCols = []
      if(this.isSupplier && this.source === 'edit_base'){
          priceLevelCols = this.distributionLevelList.map(item => {
            return {
              prop: 'distributionPrice_' + item.value,
              attrs: {label: item.value+'级分销价格',width:160,noRequired: true,isDistributionState:this.isDistributionState}, 
              input: {type: 'distributionPriceInput',onlyTable:true}
            }
          })
      }
      if (this.isDistributorProd) {
        return [
          {prop: 'sellerCatName', attrs: {label: '规格分类', width: 150, noRequired: true, "show-overflow-tooltip": true }, slot: true },
          {prop: 'skuOuterId', attrs: {label: '商品编码', width: 200}, input: {type: 'text', onlyTable: true}, headerSlot: true},
          {prop: 'baseSellingPrice', attrs: {label: '基本售价'}, input: {type: 'number', validator: valiNumVoid}},
          {prop: 'salesPrice', attrs: {label: '销售价'}, input: {type: 'number', validator: valiNumVoid}},
          {prop: 'marketPrice', attrs: {label: '市场价'}, input: {type: 'number', validator: valiNumVoid}},
          {prop: 'purchasePrice', attrs: {label: '成本价'}, input: {type: 'number', validator: valiNumVoid}},
          {
            prop: 'erpSumStock', 
            attrs: {label: 'erp库存', width: 120,'header-tooltip': '可用库存和虚拟库存之和'},
            input: { type: 'number' } ,
            isLoading:this.isErpSumStockLoading,
            disabledFn:(row) => {return true}
          },
          {prop: 'stock', attrs: {label: '库存', width: 120}, input: {type: 'number', validator: valiNumVoid, attrs: {precision: 0}}, headerSlot: true, slot: true, disabledFn: (row) => row.stockType == 1 },
          {prop: 'weight', attrs: {label: '重量(kg)', noRequired: true}, input: {type: 'number', attrs: { precision: 3 }}},
          ...priceLevelCols,
          {prop: 'erpOuterId', attrs: {label: 'ERP主商家编码', width: 150, noRequired: true}},
          {prop: 'erpSkuOuterId', attrs: {label: 'ERP规格商家编码', width: 150, noRequired: true}},
        ]
      } else {
        return [
          {prop: 'sellerCatName', attrs: {label: '规格分类', width: 150, noRequired: true, "show-overflow-tooltip": true }, slot: true },
          {prop: 'skuOuterId', attrs: {label: '商品编码', width: 200}, input: {type: 'text', onlyTable: true}, headerSlot: true},
          {prop: 'baseSellingPrice', attrs: {label: '基本售价', 'header-tooltip': '商品的基础销售价，一般同销售价，可调整，用于供销商核定分销价', width: 130}, input: {type: 'number', validator: valiNumVoid}},
          {prop: 'salesPrice', attrs: {label: '销售价', 'header-tooltip': '即商品零售价，出售单件商品标定的销售价格', width: 100}, input: {type: 'number', validator: valiNumVoid}},
          {prop: 'marketPrice', attrs: {label: '市场价', 'header-tooltip': '即建议零售价，基于市场情况的指导价格', width: 100}, input: {type: 'number', validator: valiNumVoid}},
          {prop: 'purchasePrice', attrs: {label: '成本价', 'header-tooltip': '生产或采购商品的价格', width: 100}, input: {type: 'number', validator: valiNumVoid}},
          {
            prop: 'erpSumStock', 
            attrs: {label: 'erp库存', width: 120,'header-tooltip': '可用库存和虚拟库存之和'},
            input: { type: 'number' } ,
            isLoading:this.isErpSumStockLoading,
            disabledFn:(row) => {return true}
          },
          {prop: 'stock', attrs: {label: '库存'}, input: {type: 'number', validator: valiNumVoid, attrs: {precision: 0}}, disabledFn: (row) => row.stockType == 1},
          {prop: 'weight', attrs: {label: '重量(kg)', noRequired: true}, input: {type: 'number', attrs: {precision: 3}}},
          ...priceLevelCols,
          {prop: 'erpOuterId', attrs: {label: 'ERP主商家编码', width: 150, noRequired: true}},
          {prop: 'erpSkuOuterId', attrs: {label: 'ERP规格商家编码', width: 150, noRequired: true}},
        ]
      }
    },
    // 是否填写了款维度信息
    hasOnePureValue() {
      const fields = ['purePrice', 'num', 'weight', 'marketPrice', 'purchasePrice'];
      return fields.some(field => this.pureGoods[field] || this.pureGoods[field] === 0);
    },
    // 填写了款维度信息，但是没有规格明细
    isVirtualPureGood() {
      return this.hasOnePureValue && !this.skuList.length;
    },
    isDistribution(){
        return this.origin_form.isDistribution
    },
    // 是否加入分销小店 
    isDistributionState() {
      // let privacyState = this.form.privacyState;
      let distributionState = this.form.distributionState;
      // if(privacyState == 0 && distributionState == 1) { // 已加入且公开
      //   return 1
      // }
      // if(this.privacyState == 1 && distributionState == 1) { // 已加入且私密
      //   return 2
      // }
      // if(distributionState == 2 || distributionState == 0) { // 未加入
      //   return 3
      // }
      return distributionState === 1;
    },
  },
   directives: {
    loadMore: {
      bind(el, binding) {
        const selectDom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        selectDom.addEventListener('scroll', function () {
          // 判断滚动到底部
          const flag = this.scrollHeight - this.scrollTop <= this.clientHeight
          if (flag) {
            binding.value();
          }
        })
      }
    }
  },
  watch: {
    form: {
      async handler (newV) {
        const v = _.cloneDeep(newV)
        const displayCode = v.displayCode;
        this.origin_form = _.cloneDeep(v);
        localStorage.setItem('_origin_form', JSON.stringify({
          title: this.origin_form.title,
          mainImages: this.origin_form.mainImages,
          mainImages34: this.origin_form.mainImages34,
          whiteBackGroundPic: this.origin_form.whiteBackGroundPic,
          longImage: this.origin_form.longImage?.[0] || '',
          specifications: this.origin_form.specifications,
          skuList: this.origin_form.skuList || [],
          purchasePrice: this.origin_form.purchasePrice,
          weight: this.origin_form.weight,
          purePrice: this.origin_form.purePrice,
          marketPrice: this.origin_form.marketPrice,
          baseSellingPrice: this.origin_form.baseSellingPrice,
          itemSupplier: this.origin_form.itemSupplier,
          detailImages: this.origin_form.detailImages,
          description: this.origin_form.description,
          materialImage: this.origin_form.materialImage,
          // 拼多多视频同步上传
          videos: ['1:1', '3:4', '16:9'].map(ratio => (this.origin_form.videoList || []).find(v => v && v.videoRatio == ratio)?.originUrl || '').join(''),
          isDistribution: this.origin_form.isDistribution,
        }));
        if (v && v.skuList) {
          v.skuList = v.skuList.map(item => {
            const _skuid = item.skuSpecifications.map(sp => sp.valueKey).join('-')
            return {
              ...item,
              _skuid
            }
          })
        }
        
        if (v.specifications && v.specifications.length) {
          this.specifications = JSON.parse(JSON.stringify(v.specifications))
        }
        if (v.outerId) {
          this.oriOuterId = v.outerId
        }
        const videos = {};
        (v.videoList || []).forEach(item => {
          if(item && item.videoRatio) {
            videos[item.videoRatio] = item
          }
        })
        v.videos = videos;
        // 商品长图：后端返回字符串，组件需要数组格式
        if (v.longImage && typeof v.longImage === 'string') {
          v.longImage = v.longImage ? [v.longImage] : [];
        } else if (!v.longImage) {
          v.longImage = [];
        }
        this.pureGoods = {
          pureType: v.pureType || 0,
          purePrice: v.purePrice,
          num: v.num,
          weight: v.weight,
          purchasePrice: v.purchasePrice,
          marketPrice: v.marketPrice,
          stockType: v.stockType,
        }

        v.syncContent = v.syncContent || [];
        let isPrivacyDistributionState = 1;
        if(v.privacyState == 0 && v.distributionState == 1) {
          isPrivacyDistributionState = 1
        } else if(v.privacyState == 1 && v.distributionState == 1) {
          isPrivacyDistributionState = 2
        } else if(v.distributionState == 2 || v.distributionState == 0) {
          isPrivacyDistributionState = 3
        }
        this.$set(v, 'isPrivacyDistributionState', isPrivacyDistributionState);

        if (v.pureType !== 1) {
          let _stockType = 0
          if (v.skuList && v.skuList.some(({stockType}) => {
            if (stockType === 1) {
              _stockType = 1
            }
            return stockType > 0
          })) {
            _stockType = _stockType === 1 ? _stockType : 2
          }
          v.stockType = _stockType;
        }
        this.$set(this, 'self_form', v);
        this.handleBaseItemDisplay(displayCode);

        this.$nextTick(() => {
          this.specificationsFieldChanged();
          this.validPage();
        });
      },
      immediate: true
    },
    'pureGoods.pureType': {
      deep: true,
      handler: function(newVal,oldVal) {
        this.specificationsFieldChanged();
      },
      immediate: true
    },
    outerIdSame() {
      this.$nextTick(() => {
        this.validPage();
      })
    },
  },
  methods: {
    ...mapActions(['getLevels']), 
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    async queryStock(skuIds) {
      let res = await querySupplierStock({
        baseItemId: this.self_form.baseItemId,
        skuIds
      })
      let map = {};
      if (res.result === 1 && res.data) {
        res.data.forEach(({skuId, stockNum}) => {
          map[skuId] = stockNum
        })
        this.skuList.forEach(sku => {
          if (map[sku.id] !== undefined) {
            sku.stock = map[sku.id];
          }
        })
      }
    },
    stockTypeChange(v) {
      let skuIds = [];
      let needSkuIds = v === 1;
      this.skuList.forEach(sku => {
        if (!sku.stockType) {
          return ;
        }
        if (sku.stockType !== v) {
          sku.stockType = v
          needSkuIds && skuIds.push(sku.id)
        }
      })
      needSkuIds && this.queryStock(skuIds);
    },
    skuStockTypeChange(v, row) {
      let needSkuIds = v === 1;
      needSkuIds && this.queryStock([row.id])

      // 总控制开关的状态
      if (v === 2) {
        // 关闭时，当所有开关都关闭时，总开关需要关闭
        this.skuList.every(({stockType}) => stockType === v) && (this.self_form.stockType = v);
      } else {
        this.self_form.stockType = v
      }
    },
    method_clear() {
      this.oriOuterId = ''
      this.outerIdSame = false
      this.outerIdSameUrl = ''
    },
    scroll_groupImages_item(index){
      const groupImagesItem = this.$el.querySelector('.group-images-item');
      if (groupImagesItem) {
        groupImagesItem.scrollIntoView({ 
          behavior: 'smooth',
        });
      }
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
        if (this.removePureItem) {
          // 既没有填写款信息也没有规格明细
          if (!this.hasOnePureValue && !this.skuList.length) {
            this.specificationsValidResult = '请补充商品规格及规格明细';
            resolve(false);
            return;
          }
          if (this.isVirtualPureGood) {
            resolve(true);
            return;
          }
        }

        const specificationsValid = this.validateSpecifications();
        this.specificationsValidResult = specificationsValid;
        if ( this.$refs.pureSpecsFormRef) {
          const pureTypePass = await this.$refs.pureSpecsFormRef.validatePure();
          if (!pureTypePass) {
            resolve(false);
            return;
          }
        }
        if (specificationsValid !== true) {
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    async method_getFormData() {
      await this.checkSameOuterId(true);
  
      return new Promise(async(resolve, reject) => {
        this.validPage().then(valid => {
          if (!valid || this.outerIdSame) {
            this.$message.error('请完善表单')
            resolve(false)
            return false;
          }

          let partData = {
            specifications: [],
            skuList: [],
            specificationNames: [],
          }
          const displayCode = this.getDisplayCode();
          if (this.isVirtualPureGood && this.removePureItem) {
            // 填写了纯商品信息，但是没有规格明细时，自动生成一个规格
            const newSpec = this.autoCreate();
            Object.assign(partData, {
              specifications: newSpec.specifications,
              skuList: newSpec.skuList,
              specificationNames: newSpec.specificationNames,
            });
          } else {
            const [specifications, skuList] = this.getSpecificationData();

            Object.assign(partData, {
              specifications,
              skuList,
              specificationNames: this.specificationNames,
            });
          }


          partData.skuList = partData.skuList.map(item => ({
            ...item,
            baseSellingPrice: item.baseSellingPrice == "" ? 0 : item.baseSellingPrice,
            marketPrice: item.marketPrice == "" ? 0 : item.marketPrice,
            salesPrice: item.salesPrice == "" ? 0 : item.salesPrice,
            stock: item.stock == "" ? 0 : item.stock,
            outerId: this.self_form.outerId,
            imageUrl: item.skuSpecifications?item.skuSpecifications[0].imageUrl:''
          }));

          const data = {
            ...this.self_form,
            ...partData,
            categoryId: this.self_form.categoryIds.length ? this.self_form.categoryIds[0] : '',
            leafCategoryId: this.self_form.categoryIds.length ? this.self_form.categoryIds[this.self_form.categoryIds.length - 1] : '',
            itemSupplier: {
              name: this.self_form.itemSupplier?.name,
              id: this.self_form.itemSupplier?.id,
              code: this.self_form.itemSupplier?.code,
            },
            pureType: this.pureGoods.pureType,
            purePrice: this.pureGoods.purePrice,
            num: this.pureGoods.num,
            smallShopItem: this.smallShopItem,
            weight: this.pureGoods.weight,
            marketPrice: this.pureGoods.marketPrice,
            purchasePrice: this.pureGoods.purchasePrice,
            stockType: this.pureGoods.stockType,
            videoList: Object.values(this.self_form.videos).filter(Boolean),
            longImage: this.self_form.longImage?.[0] || '',
            displayCode,
            longImage: this.self_form.longImage?.[0] || '',
          };
          if(!this.isAddHand) {
            data.notCheckSyncFiledConf = !(data.syncContent && data.syncContent.length);
          } else {
            if (Array.isArray(data.shopIds)) {
              data.shopIds = data.shopIds.join(',');
            }
          }
          if(this.self_form.isPrivacyDistributionState == 1) {
            data.privacyState = 0; data.distributionState = 1
          } else if(this.self_form.isPrivacyDistributionState == 2) {
            data.privacyState = 1; data.distributionState = 1;
          } else {
            data.privacyState = null; data.distributionState = 2;
          }
          delete data.isPrivacyDistributionState;
          delete data.videos;
          resolve(data)
        });
      })
    },
    getDisplayCode () {
        let codes = [];
        this.self_form.displayCode.forEach(item => {
            if (Array.isArray(item)) {
                codes.push(...item);
            } else {
                codes.push(item);
            }
        });
        codes = [...new Set(codes)];
        return JSON.stringify(codes);
    },
    // 自动生成规格明细
    autoCreate() {
      const specifications = this.createSpecifications();
      const skuList = this.createSkuList(specifications);
      const specificationNames = this.getSpecNames(specifications);
      return {
        specifications,
        skuList,
        specificationNames,
      }
    },
    // 创建规格
    createSpecifications() {
      const specifications = [
        {
          name: '颜色',
          nameKey: '颜色',
          values: [
            { 
              name: '颜色',
              nameKey: '颜色',
              checked: true,
              value: '无规格',
              valueKey: this.$utils.genkey.get('v'),
              note: '',
              imageUrl: this.self_form.mainImages[0],
            }
          ]
        },
        {
          name: '尺码',
          nameKey: '尺码',
          values: [
            { 
              name: '尺码',
              nameKey: '尺码',
              checked: true,
              value: '无规格',
              valueKey: this.$utils.genkey.get('v'),
              note: '',
            }
          ]
        },
      ];
      return specifications;
    },
    // 创建规格明细
    createSkuList(sps) {
      const skuSpecifications = sps.map(sp => {
        return sp.values[0];
      });
      const _skuid = skuSpecifications.map(sv => sv.valueKey).join('-');
      const skuList = [
        {
          _skuid,
          skuSpecifications,
          skuOuterId: this.self_form.outerId,
          baseSellingPrice: this.pureGoods.baseSellingPrice || 0,
          salesPrice: this.pureGoods.purePrice || 0,
          marketPrice: this.pureGoods.marketPrice || 0,
          purchasePrice: this.pureGoods.purchasePrice || 0,
          stock: this.pureGoods.num || 0,
          weight: this.pureGoods.weight || 0,
        }
      ];
      return skuList;
    },
    getSpecNames(specs) {
      return specs.map(item => {
        let nameObj = {
          name: item.name
        }
        if (item.nameKey) {
          nameObj.nameKey = item.nameKey
        }
        return nameObj
      })
    },
    handleCommandSetSpecs(nameKey) {
      const item = this.specificationNames.find(item => item.nameKey === nameKey);
      this.$refs.batchSetSpecValuesDialogRef.method_open({
        title: `批量设置${item.name}`,
        nameKey: item.nameKey,
        specification: _.cloneDeep(this.specifications),
        sureFn: (specification) => {
          this.specifications = specification;
        }
      })
    },
    // 生成商品编码按钮回调
    batchGenSkuOutrerId() {
      if(this.pureGoods.pureType) return this.$message.error('纯商品不能批量生成商品编码');
      if(!this.self_form.outerId) {
        return this.$message.error('请先填写款式编码！')
      }
      this.$refs.genSkuOuterIdDialog.method_open({
        skuList: this.$refs.formItemSkuListRef.getRenderList(),
        outerId: this.self_form.outerId
      }, (skuList) => {
        this.$refs.formItemSkuListRef.setRenderList(skuList)
        this.specificationsFieldChanged();
      })
    },
    // 校验款式编码是否重复
    async checkSameOuterId(isNeedLoading = false) {
      if (!this.self_form.outerId || (this.oriOuterId && this.self_form.outerId === this.oriOuterId)) {
        // 未填写款式编码不校验
        // 初次进入时有款式编码且所填款式编码与初次进入时款式编码一致则不校验
        this.outerIdSame = false
        this.outerIdSameUrl = ''
        return;
      }
      await checkSameOuterId(this.self_form.outerId, { isNeedLoading }).then(res => {
        this.outerIdSame = res.result === 1 && res.data.isExists;
        const itemType = res.data.itemType;
        if (this.outerIdSame === true) {
          const {origin, pathname} = window.location;
          this.outerIdSameUrl = `${origin}${pathname}?action=openEdit&itemType=${itemType}&outerIds=,${this.self_form.outerId}`
        }
      })
    },
     // 视频上传成功
    videoUploadSuccess(video) {
      this.self_form.videos[video.videoRatio] = video;
    },
    // 删除视频
    videoDel(video) {
      this.self_form.videos[video.videoRatio] = null
    },
    // 新增供销商
    addSupplier() {
      this.$refs.addNewSupplier.method_open();
    },
    // 采购供销商列表
    async fetch_cgSupplierList(queryText = '') {
      this.loading = false;
      if(this.page.pageNo > this.page.pages) return;
      const _params = {
        pageNo: this.page.pageNo,
        queryType: 'name',
        queryText
      }
      const res = await getCgSupplierList(_params);
      if(!res) return;
      this.suppliers = [...this.suppliers, ...res.list];
      const total = res.total || 1;
      const pageSize = res.page.pageSize;
      const pages =  total % pageSize == 0 ? total / pageSize : total / pageSize + 1;
      this.page.pages = pages;
    },
    handleMore() {
      this.page.pageNo = this.page.pageNo + 1;
      this.fetch_cgSupplierList()
    },
    remoteMethod(query) {
      this.page.pageNo = 1;
      this.suppliers = [];
      if(query !== '') {
        this.loading = true;
        this.fetch_cgSupplierList(query)
      } else {
        this.fetch_cgSupplierList()
      }
    },
    searchSupplier() {
      this.page.pageNo = 1;
      this.suppliers = [];
      this.fetch_cgSupplierList()
    },
    getPddShopData() {
      getNoPageShopData({
        source: 'pdd'
      }).then(res => {
        const data = res.data;
        this.pddShopCount = (data.list || []).length;
      })
    },
    async getConfigData() {
      const res = await getSyncFiledConfig();
      const { fieldConfList=[], sync } = res.syncToErp || {};
      if(this.isAddHand) {
        let checkedList = [];
        fieldConfList.map(item => {
          if(item.ifEnable) {
            checkedList.push(item.field);
          }
        })

        // 如果 同步快麦通资料到ERP资料 的配置没开，默认全不勾选，赋值[]，开了读取配置的值
        this.self_form.syncContent = sync ? checkedList : [];

        this.syncToErpConfList = fieldConfList;
      }
    },
    initPddBrandList() {
      initPddBrandList({baseItemId: this.self_form.baseItemId})
    },
    handleDisplayClassifyCode (value,option) {
        const displayCode = Array.isArray(value) ? value : value ? JSON.parse(value) : [];
        const newDisplayCode = [];
        displayCode.forEach(code => {
            const a = option.some(item  => {
                if (item.code == code) {
                    newDisplayCode.push(code)
                    return true;
                } 
                return (item.list || []).some(el => {
                    if (el.code == code) {
                        newDisplayCode.push([item.code, el.code])
                        return true;
                    }
                    return false;
                });
            })
        });
        // return {
        //     ...deatilInfo,
        //    displayCode: newDisplayCode,
        // }
        return newDisplayCode;
    },
    async handleBaseItemDisplay (displayCode) {
        const res = await queryBaseItemDisplay();
        this.displayClassifyOptions = res;
        const newDisplayCode = this.handleDisplayClassifyCode(displayCode, res);
        this.$set(this.self_form, 'displayCode', newDisplayCode);

    },
    // 计算字符串的字节长度
    getTitleByteLength(value) {
      if (!value) return 0;
      let byteLength = 0;
      for (let i = 0; i < value.length; i++) {
        const char = value.charAt(i);
        // 判断是否为中文字符（包括中文标点符号）
        if (/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/.test(char)) {
          byteLength += 2;
        } else {
          byteLength += 1;
        }
      }
      return byteLength;
    },
    // 动态计算maxlength，确保不超过60字节
    getTitleMaxLength() {
      // 返回一个较大的数值，实际限制通过字节长度控制
      return 100;
    },
    // 输入时更新字节计数
    updateTitleWordCount() {
      // 这个方法主要用于触发响应式更新
      this.$forceUpdate();
    },
    getSkuErpStock(skuList){
      if(this.isRequestSkuStock){return;}// 防止重复请求
      let skuMap = {};
      let skuListMap = {};
      skuList.forEach(sku => {
        let id = sku.id || sku._skuid;
        let obj = {
            erpSysItemId:sku.erpSysItemId,
            erpSysItemSkuId:sku.erpSysSkuId
        }
        if(obj.erpSysItemId){
          let s_id = obj.erpSysItemId + '_' + obj.erpSysItemSkuId
          skuMap[s_id] = obj
          id = obj.erpSysItemId + '_' + obj.erpSysItemSkuId;
        }
        // 可能会存在相同的id，每个id用数组存储sku信息，方便处理相同id的数据
        if(skuListMap[id]){
          skuListMap[id].push(sku)
        }else{
          skuListMap[id] = [sku];
        }
      });
      this.isErpSumStockLoading = true
      let skuIds = Object.values(skuMap);
      const maxReqNum = 100;
      let reqNum = Math.ceil(skuIds.length / maxReqNum);
      const requestSkuErpStock = () => {
        if(skuIds.length){
          let _p = skuIds.splice(0, maxReqNum);
            getSkuErpStockList({params:_p}).then(res => {
              (res.stocks || []).forEach(item => {
                let id = item.erpSysItemId+'_'+item.erpSysItemSkuId;
                skuListMap[id].forEach(sku => {
                  this.$set(sku,'erpSumStock',item.sumErpStock || 0)
                })
              });
            }).finally(() => {
              reqNum--;requestSkuErpStock();
              if(reqNum === 0){ // 请求结束
                this.$set(this, 'isRequestSkuStock', true);
                this.$set(this, 'isErpSumStockLoading', false);
              }
            })
        }
      }
      for(let i=0;i<4;i++){
        requestSkuErpStock();
      }
    },
  },
  mounted() {
    this.getPddShopData();
    this.getConfigData();
    this.initPddBrandList(); 
    this.getLevels(); 
  },
}
</script>

<style lang="scss" scoped>
.form {
  .el-input, .el-textarea, .block-wrap {
    width: 100%;
  }
  ::v-deep .el-form-item-sellerCatName {
    .el-form-item__content {
      font-size: 12px;
      color: #606266;
    }
  }
  .block-wrap {
    border: 1px solid #DCDFE6;
    
  }
  .itemUrl-tip-text {
    margin: 5px;
    font-size: 12px;
    line-height: 12px;
  }
}
</style>